import React from 'react';
import './styles.css';

function Loading() {
  return <div className='loaderWrapper'><span className="loader"></span></div>;
}

export default Loading;